// product gallery video
document.querySelectorAll('video img').forEach(img => {
  img.setAttribute('alt', '');
  img.setAttribute('aria-hidden', 'true');
});

//
$(document).ready(function () {
  $('br').attr('aria-hidden', 'true');
  $('hr').attr('aria-hidden', 'true');
});

// Lantern image alt
$(document).ready(function () {
  $('img[src*="lantern.roeye.com/track.php"]').attr({
    alt: '',
    'aria-hidden': 'true'
  });
});

$(document).ready(function () {
  $('slideshow-carousel').removeAttr('tabindex');
});

// aria-label to the  Shop Now links
$(document).ready(function () {
  $('.multi-column__item').each(function () {
    var $container = $(this);

    // Get the second anchor (Shop Now)
    var $secondAnchor = $container.find('a').eq(1);

    // Get visible link text
    var linkText = $.trim($secondAnchor.text());

    // Get text from p.h4 (remove HTML automatically)
    var headingText = $.trim($container.find('p.h4').text());

    // Build aria-label
    var ariaLabel = linkText + ', ' + headingText;

    // Set aria-label
    $secondAnchor.attr('aria-label', ariaLabel);
  });
});

//External links
$(document).ready(function () {
  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);

    const currentHost = window.location.hostname.replace('www.', '');
    const linkHost = this.hostname.replace('www.', '');

    // Skip internal links
    if (linkHost === currentHost || !linkHost) return;

    const warningText = 'opens in a new tab';

    let ariaLabel = $link.attr('aria-label');

    // Case 1: aria-label exists but warning is missing
    if (ariaLabel) {
      if (!ariaLabel.toLowerCase().includes(warningText)) {
        ariaLabel = `${ariaLabel} - ${warningText}`;
        $link.attr('aria-label', ariaLabel);
      }
    } else {
      // Case 2: aria-label does not exist, build one

      const imgAlt = $link.find('img[alt]').first().attr('alt') || '';

      const visibleText = $link
        .clone()
        .children()
        .remove()
        .end()
        .text()
        .trim();

      const labelParts = [];

      if (imgAlt) labelParts.push(imgAlt);
      if (visibleText) labelParts.push(visibleText);

      labelParts.push(warningText);

      ariaLabel = labelParts.join(' - ');
      $link.attr('aria-label', ariaLabel);
    }

    // Apply external link behavior
    $link.attr({
      'title': ariaLabel,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });

    $link.addClass('external-link');
  });
});


// List of Email aria label assigned
$(document).ready(function () {

  $('a[href^="mailto:"]').each(function () {

    let email = $(this).attr('href').replace('mailto:', '').trim();


    if (email) {

      email = decodeURIComponent(email)
        .split('?')[0]
        .split('&')[0];

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(email)) {
        $(this).attr('aria-label', 'Email Address: ' + email);
      } else {

        console.warn('Invalid email address:', email);
      }
    }
  });
});

// Label For Phone Numbers
$(document).ready(function () {
  $('a[href^="tel:"]').each(function () {
    const telNumber = $(this).attr('href').replace('tel:', ''); // Remove "tel:" prefix
    const ariaNumber = telNumber.replace(/-/g, '.'); // Replace hyphens with dots
    // Use template literals for proper string interpolation
    $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
  });
});

//Empty Heading issue Fixed
$(document).ready(function () {
  $('h1, h2, h3, h4, h5, h6').each(function () {
    var $heading = $(this);
    if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
      $heading.remove();
    }
  });
});

// back to top btn focus
$(document).ready(function () {
  $('#back-to-top').on('click keydown', function (e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      const $skipLink = $('.skip-to-content').first();

      // Ensure the element can receive focus
      $skipLink
        .removeClass('sr-only')
        .attr('tabindex', '-1')
        .focus();

      // Restore after focus
      setTimeout(function () {
        $skipLink
          .addClass('sr-only')
          .removeAttr('tabindex');
      }, 300);
    }
  });
});

// Cart Drawer Focus
$(document).ready(function () {
  $('.header__cart-link a').on('click keydown', function (e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {

      // Update aria-expanded
      $(this).attr('aria-expanded', 'true');

      // Wait for the drawer to be rendered/opened
      setTimeout(function () {
        const $drawer = $('#cart-drawer');

        if ($drawer.length) {
          // Make drawer focusable if needed
          if (!$drawer.attr('tabindex')) {
            $drawer.attr('tabindex', '-1');
          }

          // Move focus to the drawer
          $drawer.focus();
        }
      }, 200);
    }
  });
});

// Adding label to add to cart
$(document).ready(function () {
  $('.product-card').each(function () {
    const productTitle = $(this).find('.product-title').text().trim();
    const addToCartButton = $(this).find('button[type="submit"]');

    if (productTitle && addToCartButton.length) {
      // Prevent duplicate sr-only text
      if (addToCartButton.find('.sr-only').length === 0) {
        addToCartButton.append(
          '<span class="sr-only"> ' + productTitle + '</span>'
        );
      }
    }
  });
});

// Issue 8 – Hero slideshow pause/play
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.slideshow__pause');
  if (!btn) return;
  var carousel = document.getElementById(btn.getAttribute('aria-controls'));
  if (!carousel || !carousel.player) return;
  var paused = btn.classList.toggle('is-paused');
  if (paused) { carousel.player.stop(); } else { carousel.player.start(); }
  btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
});


// Issue 9 – Announce slide changes made with Prev/Next
document.querySelectorAll('slideshow-carousel').forEach(function (carousel) {
  var live = document.createElement('div');
  live.className = 'sr-only';
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  carousel.appendChild(live);
  var userAction = false;
  carousel.addEventListener('click', function (e) {
    if (e.target.closest('.slideshow__arrow')) userAction = true;
  });
  carousel.addEventListener('carousel:change', function (e) {
    if (!userAction) return;
    userAction = false;
    live.textContent = 'Slide ' + (e.detail.index + 1) + ' of ' + carousel.cells.length;
  });
});


// Internal links – open in the same tab (remove target="_blank").
// Links we deliberately keep in a new tab get a hidden "opens in a new tab" warning.
(function () {
  var warningText = 'opens in a new tab';
  var currentHost = window.location.hostname.replace('www.', '');

  function warnLink(link) {
    var label = link.getAttribute('aria-label');
    if (label) {
      if (label.toLowerCase().indexOf(warningText) === -1) {
        link.setAttribute('aria-label', label + ', ' + warningText);
      }
      return;
    }
    if (link.textContent.toLowerCase().indexOf(warningText) !== -1) return;
    var span = document.createElement('span');
    span.className = 'sr-only';
    span.textContent = ' (' + warningText + ')';
    link.appendChild(span);
  }

  function fixLink(link) {
    if (link.dataset.newTabChecked) return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    if (link.hostname.replace('www.', '') !== currentHost) return; // external links handled above
    link.dataset.newTabChecked = 'true';

    // Keep new tab for admin links or links marked data-keep-new-tab
    if (link.hasAttribute('data-keep-new-tab') || link.pathname.indexOf('/admin') === 0) {
      warnLink(link);
      return;
    }
    link.removeAttribute('target');
  }

  function scan(root) {
    if (root.matches && root.matches('a[target="_blank"][href]')) fixLink(root);
    root.querySelectorAll('a[target="_blank"][href]').forEach(fixLink);
  }

  scan(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();



(function () {

  // ===== FAQ page (#32, #33) =====
  function initFaqA11y() {
    if (!location.pathname.startsWith('/apps/help-center')) return;
    const root = document.querySelector('.s4com-container');
    if (!root) return;

    // #32 – accordion state
    root.querySelectorAll('.s4com-articles').forEach((item, i) => {
      const btn = item.querySelector(':scope > a');
      const panel = item.querySelector('.s4com-article-body');
      if (!btn || !panel) return;
      panel.id = panel.id || `faq-panel-${i}`;
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-controls', panel.id);
      const sync = () => btn.setAttribute('aria-expanded', btn.classList.contains('s4com-active'));
      sync();
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class'] });
      btn.addEventListener('keydown', e => {
        if (e.key === ' ') { e.preventDefault(); btn.click(); }
      });
    });

    // #33 – copy-link icon
    const live = Object.assign(document.createElement('div'), { className: 'visually-hidden' });
    live.setAttribute('aria-live', 'polite');
    document.body.append(live);

    document.addEventListener('focusin', e => {
      const link = e.target.closest && e.target.closest('[data-copy-link]');
      if (!link) return;
      const links = [...document.querySelectorAll('[data-copy-link]')];
      const titles = [...document.querySelectorAll('[data-copy-title]')];
      const i = links.indexOf(link);
      if (i < 0 || !titles[i]) return;
      titles[i].dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
      const icon = document.getElementById('copy-faq-article-icon');
      if (!icon) return;
      icon.setAttribute('role', 'button');
      icon.tabIndex = 0;
      icon.setAttribute('aria-label', `Copy link to ${titles[i].innerText.trim()}`);
      icon.querySelectorAll('svg, span').forEach(el => el.setAttribute('aria-hidden', 'true'));
      if (!icon.dataset.a11y) {
        icon.dataset.a11y = '1';
        icon.addEventListener('keydown', ev => {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); icon.click(); }
        });
        icon.addEventListener('click', () => {
          live.textContent = '';
          setTimeout(() => (live.textContent = 'Link copied'), 50);
        });
      }
    });
  }

  // ===== Product page – Stamped reviews (#21, #22) =====
  function initStampedA11y() {
    if (!location.pathname.includes('/products/')) return;
    const shown = el => !!el && getComputedStyle(el).display !== 'none';

    const apply = () => {
      const W = document.getElementById('stamped-main-widget');
      if (!W) return;

      const tabs = [...W.querySelectorAll('[role="tab"]')];
      const panels = tabs.map(t => W.querySelector(`[role="tabpanel"][aria-labelledby="${t.id}"]`));
      if (panels.some(shown)) {
        tabs.forEach((tab, i) => {
          const panel = panels[i];
          if (!panel) return;
          const selected = shown(panel);
          tab.setAttribute('aria-controls', panel.id);
          tab.setAttribute('aria-selected', selected);
          tab.tabIndex = selected ? 0 : -1;

          if (!tab.dataset.a11y) {
            tab.dataset.a11y = '1';
            tab.addEventListener('keydown', e => {
              const all = [...W.querySelectorAll('[role="tab"]')];
              const n = all.indexOf(tab);
              let next;
              if (e.key === 'ArrowRight') next = all[(n + 1) % all.length];
              else if (e.key === 'ArrowLeft') next = all[(n - 1 + all.length) % all.length];
              else if (e.key === 'Home') next = all[0];
              else if (e.key === 'End') next = all[all.length - 1];
              else if (e.key === ' ') { e.preventDefault(); tab.click(); return; }
              if (next) { e.preventDefault(); next.focus(); next.click(); }
            });
          }
        });
      }

      [
        ['.stamped-summary-actions-newreview', '[id^="new-review-form"]'],
        ['.stamped-summary-actions-newquestion', '[id^="new-question-form"]'],
      ].forEach(([b, f]) => {
        const btn = W.querySelector(b), form = W.querySelector(f);
        if (!btn || !form) return;
        btn.setAttribute('aria-controls', form.id);
        btn.setAttribute('aria-expanded', shown(form));
      });
    };

    apply();
    let raf;
    new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(apply);
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  // ===== Add to cart – hide the "|" separator (#13) =====
  function initCartButtonA11y() {
    const hidePipes = btn => {
      const walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        const n = walker.currentNode;
        if (n.nodeValue.includes('|') && !n.parentElement.closest('[aria-hidden="true"]')) nodes.push(n);
      }
      nodes.forEach(n => {
        const frag = document.createDocumentFragment();
        n.nodeValue.split('|').forEach((part, i) => {
          if (i) {
            const pipe = Object.assign(document.createElement('span'), { textContent: '|' });
            pipe.setAttribute('aria-hidden', 'true');
            const comma = Object.assign(document.createElement('span'), { className: 'visually-hidden', textContent: ',' });
            frag.append(pipe, comma);
          }
          frag.append(part);
        });
        n.replaceWith(frag);
      });
    };
    document.querySelectorAll('button[type="submit"], button[name="add"]').forEach(btn => {
      hidePipes(btn);
      new MutationObserver(() => hidePipes(btn)).observe(btn, { childList: true, subtree: true, characterData: true });
    });
  }

  // ===== Heading levels on FAQ and blog articles (#31) =====
  function initHeadingsA11y() {
    const isFaq = location.pathname.startsWith('/apps/help-center');
    const isArticle = /^\/blogs\/[^/]+\/[^/]+/.test(location.pathname);
    if (!isFaq && !isArticle) return;
    const main = document.querySelector('main');
    if (!main || main.querySelector('h2')) return;
    main.querySelectorAll('h3, h4, h5').forEach(h => {
      h.setAttribute('aria-level', String(Number(h.tagName[1]) - 1));
    });
  }

  // ===== Init (one place for everything) =====
  function initAll() {
    try { initFaqA11y(); } catch (e) { console.warn('FAQ a11y:', e); }
    try { initStampedA11y(); } catch (e) { console.warn('Stamped a11y:', e); }
    try { initCartButtonA11y(); } catch (e) { console.warn('Cart a11y:', e); }
    try { initHeadingsA11y(); } catch (e) { console.warn('Headings a11y:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();